

























import { Vue, Component, Watch } from 'vue-property-decorator';
import RecordListContent from '@/components/record/recordListContent.vue';
import { GradesTypes } from '@/enums/gradesTypes';
import { FunctionTypes } from '@/enums/functionTypes';
import AvaivaledVue from '@/components/avaivaled.vue';

@Component({
  components: {
    'record-list-content': RecordListContent
  }
})
export default class RecordList extends AvaivaledVue {
  private GradesTypes = GradesTypes;

  private activeTab = 'report';
  private isReportChanged = false;
  private isRoutineTestChanged = false;
  private isOtherTestChanged = false;

  get schoolId(): string {
    return this.$store.getters['auth/schoolId'];
  }

  get isMini(): boolean {
    return (this as any).$mq === 'mini';
  }

  @Watch('schoolId')
  private changeSchoolId() {
    this.removeEventListener();
  }

  private created() {
    this.loadCondition();
    this.pageBackCheck(FunctionTypes.Grade);
  }

  private mounted() {
    this.addEventListener();
  }

  private deactivated() {
    this.$destroy();
  }

  private destroyed() {
    this.removeEventListener();
  }

  private loadCondition() {
    const activeTab = localStorage.getItem('recordList/activeTab');
    localStorage.removeItem('recordList/activeTab');
    if (activeTab != null) {
      this.activeTab = activeTab;
    }
  }

  private addEventListener() {
    window.addEventListener('beforeunload', this.leaving);

    const page = this.$el.getElementsByClassName('page-content-main')[0];
    page.addEventListener('scroll', this.onScroll);

    const content = this.$el.getElementsByClassName('el-tabs__content')[0];
    content.addEventListener('resize', this.onResize);

    this.onResize();
  }

  private removeEventListener() {
    window.removeEventListener('beforeunload', this.leaving);

    const page = this.$el.getElementsByClassName('page-content-main')[0];
    page.removeEventListener('scroll', this.onScroll);

    const content = this.$el.getElementsByClassName('el-tabs__content')[0];
    content.removeEventListener('resize', this.onResize);
  }

// #region スクロール時にタブを上部に固定
  private onScroll() {
    const header = this.$el.getElementsByClassName('el-tabs__header')[0];
    const content = this.$el.getElementsByClassName('el-tabs__content')[0];
    const y = content.getBoundingClientRect().top;
    if (115 > y) {
      if (!header.classList.contains('fixed')) {
        header.classList.add('fixed');
        content.classList.add('content-margin');
        this.onResize();
      }
    } else {
      if (header.classList.contains('fixed')) {
        header.classList.remove('fixed');
        content.classList.remove('content-margin');
        this.onResize();
      }
    }
  }

  private onResize() {
    const header = this.$el.getElementsByClassName('el-tabs__header')[0] as HTMLElement;

    if (header.classList.contains('fixed')) {
      const content = this.$el.getElementsByClassName('el-tabs__content')[0] as HTMLElement;
      header.style.width = `${content.offsetWidth}px`;
    } else {
      header.style.width = '';
    }
  }
// #endregion

  private leaving(e: any) {
    localStorage.setItem('recordList/activeTab', this.activeTab);

    if (this.isReportChanged || this.isRoutineTestChanged || this.isOtherTestChanged) {
      e.returnValue = '';
    }
  }
}
